import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import QRCode from "qrcode.react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { showAlert } from "redux/actions/setAppActions";
import { Layout } from "components/Layout";
import { BackButton } from "components/BackButton";

/**
 * @api {get} /classes/:id/code qr код
 * @apiGroup psychologists
 * @apiName qr код
 *
 * @apiParam {String} id ID Класса
 *
 * @apiDescription <p>Страница с QR-кодом и ссылкой на страницу регистрации ученика</p>
 * <p>Компонент <code>Code.js</code> <a href="../client/src/pages/Code.js">ссылка на файл</a></p>
 */

export const Code = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("pupils");
    const classId = useParams().id;
    const [data, setData] = useState(null);
    const link = `${window.location.origin}/pupil/${classId}`;

    useEffect(() => {
        (async () => {
            const { data } = await axios.get(`classes/${classId}`);
            setData(data);
        })();
    }, [classId]);

    const copyHandler = () => {
        window.navigator.clipboard.writeText(link);
        dispatch(showAlert({ type: "success", text: t("link_copied") }));
    };

    return (
        <Layout>
            <div className="page code-page">
                <header className="page__header">
                    <BackButton/>
                    <p className="page__title code-page__title">
                        {data?.school.name}, {data?.number} {data?.letter}
                    </p>
                </header>

                <div className="page__content code-page__content">
                    <p className={"page__content-title"}>{t("scan_qr_code")}</p>

                    <div className="code">
                        <QRCode
                            id="canvas"
                            size={234}
                            renderAs={"svg"}
                            value={link}
                            includeMargin={true}
                        />
                    </div>

                    <div className={"code-page__info"}>
                        <p className={"code-page__info-text"}>
                            “Поделитесь с учениками предложенным QR-кодом или ссылкой для перехода на форму для
                            регистрации ученика.
                            Ученику будет предложено заполнить следующие поля: ФИО, дата рождения, логин и пароль от
                            личного кабинета. При этом поле “Школа”
                            (название образовательной организации) и ФИО психолога, закрепленного за учеником (ваше ФИО)
                            будут заполнены автоматически.”
                        </p>
                    </div>
                </div>


                <div className="code-page__footer">
                    <p className="code-page__footer-title">{link}</p>
                    <p className="code-page__footer-desc">{t("pupil_registration_link")}</p>
                    <button onClick={copyHandler} className="code-page__copy-btn"/>
                </div>
            </div>
        </Layout>
    );
};
